<template>
    <div>
    </div>
</template>

<script>
import { ErrorService } from '@/main'
import notification from '@/mixins/notification';
import * as Sentry from "@sentry/browser"
import Resource from "@/components/integrations/google-analytics-oauth/oauth/Resource";

export default {
    mixins: [notification],
    methods: {
        handleConnection(code, path) {
            try {
                Resource.connect(code).then((response) => {
                    this.$store.commit('setGoogleConnection', true)
                    this.$router.push({
                        path: path
                    });
                    return;
                });
            } catch(e) {
                this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                Sentry.captureException(e)
                console.log(e)
            }
        },
    },

    mounted() {
        const code = this.$route.query.code
        const path = this.$route.query.state

        if (code && path) {
            this.handleConnection(code, path)
        }
    }
}
</script>
